export default __webpack_public_path__ + "f7e85470b10e0930b6b640b1c2972c58.png";